import { NgClass, NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { checkModifica } from 'app/utils/boolean-input';

@Component({
  selector: 'sl-social-links',
  standalone: true,
  imports: [MatIconModule, NgIf, NgClass],
  templateUrl: './social-links.component.html',
})
export class SocialLinksComponent {

    @Input() data:boolean;

    checkModifica(){
        return checkModifica()
    }


    redirect_to: string = 'https://istanze.comune.sanlazzaro.bo.it/login_federa/sso?next=' + encodeURIComponent('https://www.comune.sanlazzaro.bo.it/prenotazione-appuntamenti-uffici');



}
